<!--
 * @Author: your name
 * @Date: 2021-11-11 15:34:45
 * @LastEditTime: 2024-07-31 17:36:16
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\components\system\helpDocument.vue
-->
<template>
  <div class="help">
    <div class="title">{{$t('csh1')}}</div>
    <div class="kares">
      <div class="child-title">{{$t('csh2')}}</div>
      <div class="d-file">
        <div v-for="(item) in kares" :key="item.name">
          <help-child  :type="item.type" :url="item.url" :name="item.name"></help-child>
        </div>
        <i v-for="index in 12" :key="index" style="width: 100px"></i>
      </div>
    </div>
    <div class="pe">
      <div class="child-title">{{$t('csh3')}}</div>
      <div class="d-file">
        <div v-for="(item) in pe" :key="item.name">
          <help-child  :type="item.type" :url="item.url" :name="item.name"></help-child>
        </div>
        <i v-for="index in 12" :key="index" style="width: 100px"></i>
      </div>
    </div>
    <div class="phone">
      <div class="child-title">{{$t('csh4')}}</div>
      <div class="d-file">
        <div v-for="(item) in phone" :key="item.name">
          <help-child  :type="item.type" :url="item.url" :name="item.name"></help-child>
        </div>
        <i v-for="index in 12" :key="index" style="width: 100px; height: 0px;"></i>
      </div>
    </div>
  </div>
</template>

<script>
import HelpChild from './children/HelpChild'

let kares = [
  { type: "pdf", url: "Kares云平台/", name: "Kares使用手册2.0.pdf" },
  { type: "mp4", url: "Kares云平台/", name: "Kares云平台-用户注册.mp4" },
  { type: "mp4", url: "Kares云平台/", name: "Kares云平台-快速入门.mp4" },
  { type: "mp4", url: "Kares云平台/", name: "Kares云平台-高级发布.mp4" },

];
let pe = [
  { type: "pdf", url: "PE软件/", name: "PE软件-使用说明书V3.2.0.pdf" },
  { type: "pdf", url: "PE软件/", name: "PE软件-屏体监控操作说明.pdf" },
  { type: "pdf", url: "PE软件/", name: "PE软件-字体添加操作步骤.pdf" },
  { type: "mp4", url: "PE软件/", name: "PE软件-节目制作.mp4" },
  { type: "mp4", url: "PE软件/", name: "PE软件-节目发布.mp4" },
  { type: "mp4", url: "PE软件/", name: "PE软件-终端控制.mp4" },
  { type: "mp4", url: "PE软件/", name: "PE软件-字体添加.mp4" }
];
let phone = [
  { type: "pdf", url: "手机APP/", name: "手机APP-潘多拉盒子使用说明-V3.6.2.pdf" },
  { type: "pdf", url: "手机APP/", name: "手机APP-屏体监控操作步骤.pdf" },
  { type: "pdf", url: "手机APP/", name: "手机APP-字体添加操作步骤.pdf" },
  { type: "mp4", url: "手机APP/", name: "手机APP-字体添加.mp4" }
];
export default {
  name: "helpDocument",
  data() {
    return {
      kares,
      pe,
      phone
      // taskList: [],
      // delay: 1000, // ms
      // typeLogout: "logout",
      // typeLogin: "login",
    }
  },
  methods: {
    // login(sn) {
    //   // if (!this.taskList.find((task) => task.sn = sn)) {
    //   //   this.taskList.push({ sn, type: this.typeLogin, timeoutId: this.timeout(sn, this.typeLogin) });
    //   // }
    //   // this.remove(sn, this.typeLogout);
    //   this.addTask(sn, "login", "logout");
    // },
    // logout(sn) {
    //   this.addTask(sn, "logout", "login");
    // },
    // hdmiIn(sn) {
    //   this.addTask(sn, "hdmiIn", "hdmiOut");
    // },
    // hdmiOut(sn) {
    //   this.addTask(sn, "hdmiOut", "hdmiIn");
    // },
    // addTask(sn, addType, delType) {
    //   if (!this.taskList.find((task) => (task.sn === sn) && (task.type === addType))) {
    //     this.taskList.push({ sn, type: addType, timeoutId: this.timeout(sn, addType) });
    //   }
    //   this.remove(sn, delType);
    // },
    // remove(sn, type) {
    //   let index = this.taskList.findIndex((task) => (task.sn === sn) && (task.type === type));
    //   clearTimeout(this.taskList[index].timeoutId);
    //   this.taskList.splice(index, 1);
    // },
    // timeout(sn, type) {
    //   return setTimeout(() => {
    //     this.sendMsg(sn, type);
    //   }, this.delay);
    // },
    // sendMsg(sn, type) {
    //   console.log(sn, type);
    //   switch (type) {
    //     case "login":
    //       break;
    //     default:
    //       break;
    //   }
    // }
  },
  components: {
    HelpChild
  }
}
</script>

<style lang="scss" scoped>
.help {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title {
    height: 50px;
    line-height: 50px;
    font-size: 22px;
    color: #fff;
    text-align: center;
    background-image: linear-gradient(
        270deg,
        #86eae7 0%,
        #4cccf0 50%,
        #11adf8 100%
      ),
      linear-gradient(#dddddd, #dddddd);
    background-blend-mode: normal, normal;
  }
  .kares,
  .pe,
  .phone {
    width: calc(100% - 8px);
    margin: 4px;
    border-radius: 8px;
    height: 33%;
    background-color: #edfbff;
    display: flex;
    flex-direction: column;
    .child-title {
      height: 40px;
      line-height: 42px;
      font-size: 18px;
      padding-left: 10px;
      border-bottom: 2px solid #d7ecf3;
    }
    .d-file {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      overflow-y: scroll;
    }
  }
  // .kares {
  //   width: 100%;
  //   height: 33%;
  // }
  // .pe {
  //   width: 100%;
  //   height: 33%;
  // }
  // .phone {
  //   width: 100%;
  //   height: 33%;
  // }
}
</style>